/***
 * 將未分類的旅館依 “主題” 及 “區域” 做分類
 */
export function CuratorialSegmentCombination() {
  
  // 重組各主題區域名稱及各區域對應的產品
  let _classifyHotelOriginDataBySegmentName = async function (theme_product_list) {
    
    // 存放分類後的 “區域名稱” 及 “產品資訊”
    let HotelSegment = {
      hotel_segment_name_list: [],
      hotel_product_list: [],
    };
    let hotel_segment_list = [];
    let HotelTemporarySpace = {};
    ;

    // 把 product_segment_name 當作 key 存放在 hotel_segment_list
    // hotel_segment_list 會存放各主題產品
    theme_product_list.forEach(function (product_list) {
      HotelTemporarySpace = {};

      product_list.forEach(function (product_item) {
        let product_segment = product_item.product_segment_name;
        if (HotelTemporarySpace[product_segment]) {
          HotelTemporarySpace[product_segment].push(product_item);
        } else {
          HotelTemporarySpace[product_segment] = new Array();
          HotelTemporarySpace[product_segment].push(product_item);
        }
      });
      hotel_segment_list.push(HotelTemporarySpace);
    });

    // HotelSegment.hotel_product_list：存放各主題分區行程
    // HotelSegment.hotel_segment_name_list：存放各主題分區名稱
    hotel_segment_list.forEach(function (theme_hotels, index) {
      HotelSegment.hotel_segment_name_list.push(Object.keys(theme_hotels));
      HotelSegment.hotel_product_list[index] = new Array();

      Object.keys(theme_hotels).forEach(function (hotel) {
        HotelSegment.hotel_product_list[index].push(theme_hotels[hotel]);
      });
    });

    return HotelSegment;
  };
  return {
    classifyHotelOriginDataBySegmentName: _classifyHotelOriginDataBySegmentName,
  };
}
